export default __webpack_public_path__ + "static/media/KOD0086-min.625a9989.webp";